import axios from '../../api/instance';

const namespace = 'order_salt/';

export const SET_SUBMITTING_ORDER = namespace + 'SET_SUBMITTING_ORDER';
export const SUBMIT_ORDER = namespace + 'submit';
export const GET_SUBMITTING_ORDER = namespace + 'GET_SUBMITTING_ORDER';


export default {
    state: {
        amount: null,
        submittingOrder: false,
    },
    mutations: {
        [SET_SUBMITTING_ORDER]: (state, submitting) => state.submittingOrder = submitting,
    },
    actions: {
        async [SUBMIT_ORDER](_,payload) {
            return await axios.post('planners/api/planners/customer_contact_moment_selection', payload);
        },
    },
    getters: {
        [GET_SUBMITTING_ORDER]: (state) => state.submittingOrder,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/order_salt.js